const initialState = {
  noViaja: null,
};

const formNoViaja = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FORMNOVIAJA':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default formNoViaja;
